<script lang="ts">
export default {
  name: 'AddWidgetModal',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import AppModal from '@/components/v2/AppModal.vue';
import widgetRegistry from './widgetRegistry';
import type { AppState } from '@/store';

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  close: [];
  add: [widgetType: string];
}>();

const store = useStore<AppState>();

const widgets = computed(() =>
  Object.entries(widgetRegistry)
    .filter(([, def]) => !def.canAccess || def.canAccess(store.state.user))
    .map(([type, def]) => ({ type, ...def })),
);
</script>

<template>
  <AppModal
    :show="show"
    title="Add Widget"
    cancel-button-label="Close"
    :handle-cancel="() => emit('close')"
    size="lg">
    <template #content>
      <div class="flex flex-col gap-3">
        <div
          v-for="w in widgets"
          :key="w.type"
          class="flex items-center justify-between gap-3 rounded-lg border p-3">
          <div>
            <div class="font-medium">{{ w.displayName }}</div>
            <div class="text-sm text-base-content/60">{{ w.description }}</div>
          </div>
          <button
            class="btn text-white btn-sm btn-primary"
            @click="emit('add', w.type)">
            Add
          </button>
        </div>
      </div>
    </template>
    <template #actions>
      <button
        class="btn btn-sm"
        @click="emit('close')">
        Close
      </button>
    </template>
  </AppModal>
</template>
